module.exports = __webpack_public_path__ + "static/media/quiz.bc3465cc.svg";